import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { enProduccionConMemForegroundOnPage } from '../enProduccionConMemReadableText';
import { MARIA_EUGENIA_MORENO_PORTRAIT_SRC, EN_PRODUCCION_CON_MEM_TNO_SHOW_URL } from '../brandAssets';
import { MARIA_EUGENIA_BIO_LEAD, MARIA_EUGENIA_BIO_PARAGRAPHS } from './enProduccionConMemHeroCopy';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();
  const headingColor = enProduccionConMemForegroundOnPage(theme);
  const accent = theme.palette.secondary.main;

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        />
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          gutterBottom
          align="center"
          sx={{ fontFamily: 'Georgia, "Times New Roman", serif', color: headingColor }}
        >
          En Producción con MEM: marcas, medios y conversaciones que importan
        </Box>
        <Typography variant="h6" component="p" color="textSecondary" align="center">
          Con <strong>María Eugenia Moreno</strong>, el programa acerca la cultura publicitaria a la audiencia: casos
          reales, tendencias y decisiones de inversión con lenguaje claro. Tu marca se asocia a creatividad, negocio y
          un entorno editorial brand safe en TNO Network.
        </Typography>
        <Typography
          variant="h5"
          component="p"
          color={accent}
          align="center"
          sx={{ mt: 3, mb: 2, fontStyle: 'italic', fontFamily: 'Georgia, "Times New Roman", serif' }}
        >
          Ideas que venden, con respaldo editorial
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href={EN_PRODUCCION_CON_MEM_TNO_SHOW_URL}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{
              color: headingColor,
              '&:hover': { color: accent },
            }}
          >
            tnonetwork.com/show/enproduccionconmem
          </Link>
        </Typography>
        <Typography variant="body1" component="p" color="textSecondary" align="center" sx={{ mt: 1 }}>
          <strong>Streaming en vivo</strong> y biblioteca On-Demand en la plataforma TNO Network. Síguenos en{' '}
          <Link
            href="https://www.instagram.com/tnonetwork/"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{
              color: headingColor,
              '&:hover': { color: accent },
            }}
          >
            @tnonetwork
          </Link>{' '}
          para calendario, estrenos y contenido derivado.
        </Typography>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src={MARIA_EUGENIA_MORENO_PORTRAIT_SRC}
                alt="María Eugenia Moreno — En Producción con MEM"
                sx={{
                  width: { xs: 200, sm: 250, md: 300 },
                  height: { xs: 200, sm: 250, md: 300 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  objectPosition: 'center top',
                  boxShadow: 3,
                  border: `3px solid ${accent}`,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography
              variant="h5"
              fontWeight={700}
              gutterBottom
              sx={{ fontFamily: 'Georgia, "Times New Roman", serif', color: headingColor }}
            >
              NUESTRA ANCLA: MARÍA EUGENIA MORENO
            </Typography>
            <Typography
              variant="h6"
              fontWeight={600}
              gutterBottom
              sx={{ fontFamily: 'Georgia, "Times New Roman", serif', color: headingColor, lineHeight: 1.35 }}
            >
              {MARIA_EUGENIA_BIO_LEAD}
            </Typography>
            {MARIA_EUGENIA_BIO_PARAGRAPHS.map((p, i) => (
              <Typography key={i} variant="body1" color="textSecondary" sx={{ mb: 2, lineHeight: 1.75 }}>
                {p}
              </Typography>
            ))}
            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
              Equipo, calendario y novedades del programa:{' '}
              <Link
                href={EN_PRODUCCION_CON_MEM_TNO_SHOW_URL}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: headingColor, fontWeight: 600, '&:hover': { color: accent } }}
              >
                ficha en TNO Network
              </Link>
              .
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
